/**
 * MSAL Authentication Configuration
 * Configured for single-tenant (organizational accounts only)
 */
import { BrowserCacheLocation, Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    // Use current origin so redirect URI always matches the URL the user is on (custom domain or default)
    redirectUri: typeof window !== 'undefined' ? window.location.origin : (process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000'),
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : (process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000'),
  },
  cache: {
    // Persist auth cache across tabs/browser restarts to avoid repeated sign-in prompts.
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0: console.error(message); return;
          case 1: console.warn(message); return;
          case 2: console.info(message); return;
          case 3: console.debug(message); return;
        }
      },
    },
  },
};

/**
 * Scopes for initial login
 * Include Power BI scopes to get consent upfront
 */
export const loginRequest = {
  scopes: [
    'User.Read',
    'https://analysis.windows.net/powerbi/api/Report.Read.All',
    'https://analysis.windows.net/powerbi/api/Dataset.Read.All',
  ],
};

/**
 * Scopes for acquiring Power BI API tokens
 */
export const tokenRequest = {
  scopes: [
    'https://analysis.windows.net/powerbi/api/Report.Read.All',
    'https://analysis.windows.net/powerbi/api/Dataset.Read.All',
  ],
};
